<template>
  <v-flex xs12 class="allNotesCard__container-item -fake mb-2">
    <v-card color="" class="white--text noteItem">
      <v-toolbar color="accent" dark window class="allNotesCard__container-item__toolbarTitle" >
        <v-toolbar-title >
          <div class="toolbarTitle__name">Загрузка...</div>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title primary-title class="noteContent">
        <div class="noteContent__card">
            <div style="width:100%; height: 20px; background-color:#e6e6e6;border-radius:5px;margin-bottom:10px;"></div>
            <div style="width:80%; height: 20px; background-color:#e6e6e6;border-radius:5px;margin-bottom:10px;"></div>
            <div style="width:60%; height: 20px; background-color:#e6e6e6;border-radius:5px;margin-bottom:10px;"></div>
            <div style="width:40%; height: 20px; background-color:#e6e6e6;border-radius:5px;margin-bottom:10px;"></div>
            <div style="width:20%; height: 20px; background-color:#e6e6e6;border-radius:5px;margin-bottom:10px;"></div>
        </div>  
      </v-card-title>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: 'NoteFake'
};

</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/apps/bpm/notes/components/notes/NoteFake.vue